import React from 'react';

interface AppTableHeaderCellProps {
  children?: React.ReactNode;
  label?: string;
  sortable?: boolean;
  onSort?: () => void;
  sorted?: 'asc' | 'desc' | null;
  className?: string;
}

const AppTableHeaderCell: React.FC<AppTableHeaderCellProps> = ({
  children,
  label,
  sortable = false,
  onSort,
  sorted = null,
  className = ''
}) => (
  <th
    className={`px-4 py-3 font-bold text-lg font-zain whitespace-nowrap select-none ${sortable ? 'cursor-pointer' : ''} ${className}`}
    onClick={sortable ? onSort : undefined}
    style={{userSelect: 'none', color: 'var(--color-table-header-text, var(--color-primary))'}}
    scope="col"
  >
    <div className="flex items-center justify-start gap-2">
      {children || label}
      {sortable && (
        <span className="ml-2">
          {sorted === 'asc' ? '▲' : sorted === 'desc' ? '▼' : '↕'}
        </span>
      )}
    </div>
  </th>
);

export default AppTableHeaderCell;
